import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sigecom-radio-button',
  template: `
    <label class="flex items-center gap-2 cursor-pointer">
      <input
        type="radio"
        [name]="name"
        [checked]="selected === value"
        (change)="select()"
        class="
          appearance-none
          w-4 h-4
          rounded-full
          border-2 border-sigecom-dark-gray
          box-border
          checked:border-cbde-dark-blue
          checked:shadow-[inset_0_0_0_2px_rgb(8,11,52)]
        "
      />
      <span>{{ label }}</span>
    </label>
  `,
})
export class RadioButtonComponent {
  @Input() label = '';
  @Input() name!: string;
  @Input() value: any;
  @Input() selected: any;

  @Output() selectedChange = new EventEmitter<any>();

  select() {
    this.selectedChange.emit(this.value);
  }
}
